import firebase from 'firebase';
import fetch from 'isomorphic-fetch';

const storage = firebase.storage();

export function getDownloadURL(url) {
	return storage.ref()
		.child(url)
		.getDownloadURL();
}

export function createObjectURL(response) {
	return response.blob().then(data => URL.createObjectURL(data));
}

/**
 * Download data from url and return promise with object url.
 *
 * @param {string} url - URL in firebase storage bucket
 * @return {Promise} Promise object represents URL to downloaded blob-object */
export default function download(firebaseURL) {
	return getDownloadURL(firebaseURL).then(fetch).then(createObjectURL);
}



// WEBPACK FOOTER //
// ./src/client/firebase/storage/download.js